// src/lib/tier.ts
// Utility helpers for the feature-tier system.

export type UserTier = "tier_1" | "tier_2" | "tier_3";

/** The only category visible to Tier 1 MSP users */
export const TIER1_MSP_CATEGORY = "Cybersecurity Starter Assessments";

/**
 * Safely extract the tier from a user/profile object.
 *
 * Resolution order:
 *  1. Explicit `tier_1` | `tier_2` | `tier_3` on the user/profile.
 *  2. Portfolio managers without an explicit tier default to `tier_2`
 *     so they unlock the full cross-client / portfolio analytics dashboard.
 *  3. Everyone else defaults to `tier_1`.
 */
export function getUserTier(
  user: { tier?: string; roles?: string[] } | null | undefined,
): UserTier {
  const raw = user?.tier;
  if (raw === "tier_1" || raw === "tier_2" || raw === "tier_3") return raw;
  if (Array.isArray(user?.roles) && user!.roles!.includes("portfolio_manager")) {
    return "tier_2";
  }
  return "tier_1";
}
